import { useState, useEffect } from 'react';

export function useAdmin() {
  const [adminEnabled, setAdminEnabled] = useState(false);
  
  // Load admin state from localStorage on mount
  useEffect(() => {
    const isAdmin = localStorage.getItem('trinity_is_admin');
    setAdminEnabled(isAdmin === 'true');
  }, []);

  // Admin status is purely based on login credentials now
  const isAdmin = adminEnabled;

  return { 
    isAdmin,
    adminEnabled,
    setAdminEnabled
  };
} 